export class Tweet {

  public id!: number;
  public contents!: string;
  public type!: Type;
  public postUserName?: string;

  constructor(parameters?: Partial<Tweet>) {
    Object.assign(this, parameters);
  }

}

export enum Type {
  left = 'left',
  right = 'right',
}

